import { ReactComponent as Flags404 } from '@backrs_ui/common-ui/src/assets/images/404-image.svg';

import { Box, Button, SxProps, Theme, Typography } from '@mui/material';

import { appStrings } from '../assets/appStrings';
import { TYPOGRAPHY_VARIANTS } from '../designSystem/typography/typography';

const NOT_FOUND_STRINGS = appStrings.modules.notFound404;

type NotFound404Props = Readonly<{
  onClick?: () => void;
}>;

export const NotFound404 = ({ onClick }: NotFound404Props) => {
  return (
    <Box sx={containerSx}>
      <Box sx={imageContainerSx}>
        <Flags404 />
      </Box>

      <Typography sx={notFoundTextSx} variant="display-xl-medium">
        {NOT_FOUND_STRINGS.title}
      </Typography>

      {onClick && (
        <Button id="not-found-action-btn" onClick={onClick} variant="contained">
          {NOT_FOUND_STRINGS.action}
        </Button>
      )}
    </Box>
  );
};

const containerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100svh',
  gap: { xs: '2rem', sm: '4rem' },
  width: '100%',
} as const;

const notFoundTextSx: SxProps<Theme> = {
  textAlign: 'center',
  fontSize: {
    xs: '32px',
    sm: TYPOGRAPHY_VARIANTS['display-xl-medium'].fontSize,
  },
} as const;

const imageContainerSx: SxProps<Theme> = {
  svg: {
    width: '100%',
    height: '100%',
  },
} as const;
